import { AppNotification, ToastType } from '@/shared/models/AppNotification'

export type Toast = {
  message: string
  icon: 'loading' | 'success' | 'warning' | 'error'
  background: 'success' | 'error' | 'loading' | 'warning'
  id?: string
  path?: string
  isPersistent?: boolean
}

export type ToastFn = (toast: AppNotification) => Toast

export const makeToast = (toast: AppNotification) => {
  let toastObject = {
    message: toast.message,
    id: toast.id,
    path: toast.path,
    isPersistent: toast.isPersistent,
  } as Toast

  ;({
    [ToastType.SUCCESS]: () => {
      toastObject = { ...toastObject, icon: 'success', background: 'success' }
    },
    [ToastType.LOADING]: () => {
      toastObject = { ...toastObject, icon: 'loading', background: 'loading' }
    },
    [ToastType.ERROR]: () => {
      toastObject = { ...toastObject, icon: 'error', background: 'error' }
    },
    [ToastType.WARNING]: () => {
      toastObject = { ...toastObject, icon: 'warning', background: 'warning' }
    },
  })[toast.type]()

  return toastObject
}
